<template>
  <b-modal
    id="modal-editProject"
    title="Uredi podatke projekta"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="white"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="newProject">
          <b-form-row>
            <b-col cols="6">
              <b-form-group description="Naziv projekta">
                <b-input
                  required
                  size="md"
                  v-model="form.title"
                  type="text"
                  placeholder="Projekt XYZ"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group description="Naslov, ki se pokaže nad karticami">
                <b-input
                  required
                  size="md"
                  v-model="form.matchup_title"
                  type="text"
                  placeholder="Izberite favorita"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12">
              <h6 class="mb-0">Uvodni tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže, ko uporabnik izpolnjuje svoje podatke
              </small>
              <TipTap
                v-bind:richdata="form.description"
                @htmlChange="descriptionChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Intro tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže na uvodni strani pred karticami</small
              >
              <TipTap
                v-bind:richdata="form.intro_text"
                @htmlChange="introChanged"
              />
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-editProject')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Posodobi podatke projekta
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";
import TipTap from "@/components/tools/TipTap.vue";

export default {
  components: { TipTap },
  props: ["form"],
  data() {
    return {
      isSending: false,
    };
  },

  mounted: function() {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      let submitData = {
        title: this.form.title,
        description: this.form.description,
        intro_text: this.form.intro_text,
        matchup_title: this.form.matchup_title,
      };

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/projects/${this.form.id}`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(submitData),
          method: "PUT",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-editProject");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    introChanged(value) {
      this.form.intro_text = value;
    },
    descriptionChanged(value) {
      this.form.description = value;
    },
  },
};
</script>
